module.exports = __webpack_public_path__ + "home_slide_1.png?2e3a0bce556ada3f7009493fe60f9f31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_slide_1.png
// module id = 175
// module chunks = 0